(function() { window.GUID_c3b0b70d_2120_4556_8643_27990d7c8a52 = { getGuid: function() { return "c3b0b70d-2120-4556-8643-27990d7c8a52"; } }; })();
var CS;
(function (CS) {
    class ToolBar {
        constructor(toolBarId) {
            let me = this;
            me.ToolBarId = toolBarId;
            me.ToolBarUI = $('#' + me.ToolBarId);
            if (me.ToolBarUI.length == 0) {
                return;
            }
            me.ToolBarContentUI = me.ToolBarUI.find('.CSToolBarContent');
            me.PrepareToolBar();
        }
        PrepareToolBar() {
            let me = this;
            $(window).resize(function () {
                me.UpdateVisibilityOfShowMoresButton();
            });
            CS.on('click.toolbar menuShow.toolbar', function (e) {
                if (me.callByButton) {
                    me.callByButton = false;
                    return;
                }
                me.ToolBarUI.removeClass('IsOpened');
                me.UpdateVisibilityOfShowMoresButton();
            });
            me.ToolBarUI.find('.ShowMoresButton').on('click', function (e) {
                me.callByButton = true;
                if (me.ToolBarUI.hasClass('IsOpened')) {
                    me.ToolBarUI.removeClass('IsOpened');
                }
                else {
                    me.ShowMores();
                }
                me.UpdateVisibilityOfShowMoresButton();
            });
            me.ToolBarContentUI.on('scroll', function (e) {
                me.UpdateVisibilityOfEndsArrows();
            });
            me.UpdateVisibilityOfShowMoresButton();
            me.DetectIsStackToBottom();
        }
        ShowMores() {
            var me = this;
            me.ToolBarUI.addClass('IsOpened');
            me.DetectIsStackToBottom();
        }
        DetectIsStackToBottom() {
            var me = this;
            if (this.ToolBarContentUI.offset().top + this.ToolBarContentUI.outerHeight() >= (window.innerHeight - 10)) {
                me.ToolBarUI.addClass('StackToBottom');
            }
        }
        UpdateVisibilityOfShowMoresButton() {
            let me = this;
            if (me.ToolBarUI.hasClass("Stretchable")) {
                let count = me.ToolBarContentUI.children().length;
                if (count * 45 < me.ToolBarContentUI[0].offsetWidth) {
                    me.ToolBarContentUI.children().css('width', (me.ToolBarContentUI.width() - 2) / count);
                }
            }
            let pageToolbar = me.ToolBarContentUI.children("#PageToolBar");
            if (pageToolbar.length > 0) {
                let count = pageToolbar.children().length;
                if (count > 0) {
                    var totalWidth = 0;
                    me.ToolBarContentUI.children().not("#PageToolBar").each(function (index) {
                        totalWidth += $(this).width();
                    });
                    totalWidth = me.ToolBarContentUI[0].offsetWidth - totalWidth - 15;
                    //pageToolbar.css("width", totalWidth + "px");
                    if (count * 45 < totalWidth) {
                        pageToolbar.children().css('width', totalWidth / count - 4);
                        pageToolbar.find(".IsDisabledOverlay").css('width', totalWidth / count - 4);
                    }
                    document.body.style.zoom = "1.0000001";
                }
            }
            if (me.ToolBarContentUI[0].scrollWidth > me.ToolBarContentUI[0].offsetWidth + 1) {
                me.overflowWidth = me.ToolBarContentUI[0].offsetWidth;
                me.ToolBarUI.addClass('Overflow');
            }
            else {
                me.ToolBarUI.removeClass('Overflow');
            }
            me.UpdateVisibilityOfEndsArrows();
        }
        UpdateVisibilityOfEndsArrows() {
            let me = this;
            //1 pour eviter problemes avec ios
            if (me.ToolBarContentUI[0].scrollLeft <= 1) {
                me.ToolBarUI.addClass('ReachLeft');
            }
            else {
                me.ToolBarUI.removeClass('ReachLeft');
            }
            if (me.ToolBarContentUI[0].scrollLeft + me.ToolBarContentUI[0].offsetWidth >= me.ToolBarContentUI[0].scrollWidth - 1) {
                me.ToolBarUI.addClass('ReachRight');
            }
            else {
                me.ToolBarUI.removeClass('ReachRight');
            }
        }
    }
    CS.ToolBar = ToolBar;
})(CS || (CS = {}));

//# sourceMappingURL=ToolBar.js.map
